export default __webpack_public_path__ + "static/media/4.9b5c823e.JPG";